<template>
  <div class="delete-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('ecc.storage.unmountDialog.header')"
      :visible="visible"
      width="558px"
      :before-close="handleClose"
    >
      <div class="modal-tipsbox">
        <span class="el-icon-warning tip-icon"></span>
        <p class="del-title">
          {{ $t('ecc.storage.unmountDialog.ask') }} <span>{{ tag }} </span>?
        </p>
        <div class="del-subtitle">
          <el-checkbox v-model="checked"/>
          <p class="tips">{{ $t('ecc.storage.unmountDialog.agreement') }} </p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('ecc.storage.unmountDialog.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="unmount">{{ $t('ecc.storage.unmountDialog.buttons.umount') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sn: '',
      tag: '',
      visible: false,
      checked: false,
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
      },
    },
  },
  methods: {
    async unmount() {
      if (!this.checked) {
        this.$message.error('Please agree to the above statement')
        return false
      }
      let data = {sn: this.sn}
      let res = await this.$http.post('/disks/unmount', data).then((res) => {
        return res
      }).catch((err) => {
        return err
      })

      res = res.data
      if (res.code === -1) {
        this.$message.error(res.message)
        return false
      }
      this.$message.success(res.message)
      this.visible = false
      this.$emit('reload-detail');
    },
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped lang="scss">
.modal-tipsbox {
  padding-left: 60px;
  position: relative;

  .tip-icon {
    width: 40px;
    height: 40px;
    font-size: 40px;
    color: #f7ba2a;
    position: absolute;
    left: 0;
    top: -2px;
  }

  .del-title {
    font-size: 14px;
    color: #2d3037;
    line-height: 18px;
    margin-bottom: 6px;

    span {
      color: #3377ff;
      margin-left: 6px;
    }
  }

  .del-subtitle {
    font-size: 14px;
    color: #5E6D81;
    line-height: 22px;
    display: flex;

    .tips {
      color: #5E6D81;
      margin-left: 12px;
      margin-right: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/server/DiskUnmount.vue